import * as Yup from 'yup'

/*
  Transferência entre contas Cutilei. `availableBalance` entra no formulário apenas como
  referência do teto e não é enviado no POST — a API reconfere o saldo antes de debitar.

  Não há valor mínimo: a transferência interna é liquidada dentro do mesmo banco e não
  tem tarifa, ao contrário do saque.
*/
const bankingTransferValidator = Yup.object ().shape ({
  availableBalance: Yup.number ().default (0),

  target: Yup.object ()
    .nullable ()
    .required ('Selecione a conta de destino'),

  value: Yup.number ()
    .typeError ('Insira o valor da transferência')
    .positive ('Insira o valor da transferência')
    .max (Yup.ref ('availableBalance'), 'O valor é maior que o seu saldo disponível')
    .required ('Insira o valor da transferência'),

  description: Yup.string ()
    .max (120, 'A descrição deve ter no máximo 120 caracteres')
})

export default bankingTransferValidator
